import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext, DialogService } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { EventDialogAddPart } from './add/event-add.part';
import { EventAddDialogDataService } from './event-add-dialog-data.service';
import { ReadonlyAccessWidget } from "ui/widget/readonly-access/readonly-access.widget";

@Component({
	selector: 'event-add-dialog',
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		EventDialogAddPart,
		ReadonlyAccessWidget
	],
	templateUrl: './event-add.dialog.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./event-add.dialog.scss'],
})
export class EventAddDialog implements OnInit {
	public dialog: DialogContext<{ eventTypeId: number, languageId: number, accId?: number }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<EventAddDialog>);
	private eventAddDialogDataService = inject(EventAddDialogDataService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	icon = signal('fa-regular fa-calendar');

	header = computed(() => {
		const eventType = this.eventAddDialogDataService.data()?.eventType;
		return eventType ? `${eventType.fullName} Event - ${this.dialog.data?.languageId == LanguageId.Espanol ? 'ES' : 'EN'}` : 'No Event';
	});

	public timezone = this.util.date.getTimezone();


	public isReadonly = computed(() => !this.eventAddDialogDataService.canEdit());


	async ngOnInit() {
		const data = this.dialog.data;
		if (data) {
			await this.eventAddDialogDataService.loadData(data);
		}
	}

	close() {
		this.dialogRef.close();
	}

}
